<template>
  <div>
    <div id="wholePage">
<!--      &lt;!&ndash; 图片选择组件&ndash;&gt;-->
<!--      <image-selector ref="imageSelector" @returnImageUrl="(url)=>{handleImgSelection(url)}" :company-id="companyId" :project-id="projectId"/>-->
<!--      &lt;!&ndash; 页面头部 &ndash;&gt;-->
      <div :class="{'modeBtns': true, 'hidden': modeBtnsHidden}" v-if="editType === 0 || editType === 1">
        <el-button class="previewModeBtn" type="primary" :disabled="editType === 2 || editType === 3" throttle-time="100" @click="newProduct">
          新建
        </el-button>
        <el-button class="previewModeBtn" type="primary" :disabled="editType === 2 || editType === 3" throttle-time="100" @click="saveProduct">
          保存
        </el-button>
        <el-button class="previewModeBtn" :disabled="editType === 2 || editType === 3 || editType === 0" type="primary" throttle-time="100"
                   @click="isSaveNewConfirmShow=true">另存
        </el-button>
        <el-button class="previewModeBtn" :disabled="editType === 0" type="primary" throttle-time="100" @click="releasePage">发布</el-button>
        <el-button :disabled="!isEditMode || recordNum === 0" type="primary" throttle-time="100" @click="undo">撤销</el-button>
        <!--        <el-button class="editModeBtn" :disabled="editType === 2 || editType === 3" type="warning" throttle-time="100"-->
        <!--                   @click="editModeInit">编辑-->
        <!--        </el-button>-->
        <el-button class="previewModeBtn" :disabled="editType === 2 || editType === 3" type="success" throttle-time="100"
                   @click="handleView">预览
        </el-button>
        <el-button type="primary" throttle-time="100" @click="varDialogInfo.show=!varDialogInfo.show" v-if="!isEditMode">
          {{ varDialogInfo.show ? '隐藏' : '显示' }}变量
        </el-button>
        <el-button type="primary" throttle-time="100" @click="moveFormShow" v-show="isEditMode">整体移动</el-button>
        <el-button type="primary" throttle-time="100" @click="createImageComponent" v-show="isEditMode">插入图片</el-button>
      </div>
      <!-- 整体移动功能 -->
      <el-dialog
          title="整体移动"
          :visible.sync="isMoveFormConfirmShow">
        <el-form
            ref="moveSaveForm"
            :model="moveSaveForm">
          <el-form-item label="移动像素" prop="distance" label-position="top">
            <el-input v-model="moveSaveForm.distance"/>
          </el-form-item>
          <el-form-item label="移动方向" prop="direction" label-position="top">
            <el-radio-group v-model="moveSaveForm.direction">
              <el-radio label="向上">向上</el-radio>
              <el-radio label="向下">向下</el-radio>
              <el-radio label="向左">向左</el-radio>
              <el-radio label="向右">向右</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button @click="isMoveFormConfirmShow = false">取 消</el-button>
          <el-button type="primary" @click="moveAllContent">确 定</el-button>
        </div>
      </el-dialog>
      <!-- 另存草稿功能 从上面的div移动出来，为了层级和create一层，否则z-index高也会被下面的盖住-->
      <el-dialog
          title="另存草稿"
          :visible.sync="isSaveNewConfirmShow" class="saveNew">
        <el-form
            ref="productSaveNewForm"
            :model="productSaveNewForm">
          <el-form-item label="标题" prop="title">
            <el-input v-model="productSaveNewForm.title"/>
          </el-form-item>
          <el-form-item label="描述" prop="description">
            <el-input v-model="productSaveNewForm.description"/>
          </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button @click="isSaveNewConfirmShow = false">取 消</el-button>
          <el-button type="primary" @click="validAndSaveNewProduct">确 定</el-button>
        </div>
      </el-dialog>
      <div id="create">
        <!-- 右边侧边栏 -->
        <div id="right_menu" v-show="isEditMode">
          <!-- 动态组件下面显示的内容 -->
          <draggable-dialog
              class="draggableDialog"
              id="dynamicComponentDialog"
              :closable="false"
              width="100%"
              top="490px"
              left="0px"
              position="fixed"
              @update:show="val => {dynamicComponentDialog.show = val}">
            <template slot="header">
              组件
            </template>
            <template slot="content">
              <div class="content6">
                <div class="conponentsListItemContainer" v-for="item in componentsList" :key="item.name">
                  <div class="conponentsListItemImgContainer">
                    <img
                        class="conponentsListItemImg"
                        :src="item.url+companySuffix"

                        @dragstart="dragStartFromList($event, item)"
                    />
                  </div>
                  <div class="conponentsListItemImgName">{{ item.name }}</div>
                </div>
              </div>
              <div style="clear: both;"></div>
            </template>
          </draggable-dialog>

          <!-- 属性那一栏 -->
          <div :v-show="isEditMode === true" @click="(e)=>{e.stopPropagation()}">
            <attr-dialog  :compsJson="compsJson" @deleteClick="(id)=>{setCompsJsonItem(id,undefined)}" :multiEditingCount="multiEditingCount"
                          :attrDialog="attrDialog" v-if="multiEditingCount===0">
            </attr-dialog>
            <attr-dialog   :compsJson="compsJson" @deleteClick="(id)=>{setCompsJsonItem(id,undefined)}" :multiEditingCount="multiEditingCount"
                           :attrDialog="attrDialog" v-if="multiEditingCount===1" @changeShowAttr="changeShowAttr">
              <template slot="content">
                <component
                    v-if="attrDialog.componentId && compsJson[attrDialog.componentId]"
                    :companyId="companyId"
                    :projectId="projectId"
                    :is="typeEditorMap[compsJson[attrDialog.componentId].type]"
                    :_style="compsJson[attrDialog.componentId].style"
                    :wrapperStyle="compsJson[attrDialog.componentId].wrapperStyle"
                    :name="compsJson[attrDialog.componentId].name"
                    :url="compsJson[attrDialog.componentId].url"
                    :type="compsJson[attrDialog.componentId].type"
                    :settings="compsJson[attrDialog.componentId].settings"
                    :realtimeData="compsJson[attrDialog.componentId].realtimeData"
                    :events="compsJson[attrDialog.componentId].events"
                    :clickEvents="compsJson[attrDialog.componentId].clickEvents"
                    :variableEvents="compsJson[attrDialog.componentId].variableEvents"
                    :id="compsJson[attrDialog.componentId].id"
                    :editing="compsJson[attrDialog.componentId].editing"
                    :dynamicProps="compsJson[attrDialog.componentId].dynamicProps"
                    :bindInfo="compsJson[attrDialog.componentId].bindInfo"
                    :attrDialog="attrDialog"
                    :elementsList="elementsList"
                    :varList="varList"
                    :varJson="varJson"
                    :isArrow="compsJson[attrDialog.componentId].type==='arrow'"
                    :activeNames.sync="activeNames"
                    :scollLen.sync="scollLen"
                    @component-edited="(newSettings, styleMergeObj, wrapperStyleMergeObj, newEvents, newBindInfo, newclickEvents)=>{handleComponentEdited(newSettings, styleMergeObj, wrapperStyleMergeObj, newEvents, newBindInfo, newclickEvents)}"
                    @changeImageUrl="(id)=>{handleChangeImageUrl(id)}"
                    @updateVarjson="updateVarjson"
                >
                </component>
              </template>
            </attr-dialog>
            <multi-selection-dialog v-if="multiEditingCount>1"
                                    @multi-option="handleMultiOptions" @add-combination="handleAddCombination" @delete-combination="handleDeleteCombination"
            >
            </multi-selection-dialog>
          </div>
        </div>

        <!-- 主体页面展示，组态那些 -->
        <div :style="backgroundColor" :class="applyContent" :id="'content'+dialogCount" @dragover="dragOverOnContent" @drop="dropOnContent">
          <components-wrapper v-for="(item,key) in compsJson" :key="key" :ref="'componentsWrapper'+key"
                              :id="key"
                              :allCompsJson="compsJson"
                              :editable="isEditMode"
                              :editing="item.editing"
                              :multi-editing="item.multiEditing"
                              :style="item.wrapperStyle"
                              :settings="item.settings"
                              :is-lock="item.realtimeData.isLock ? true : false"
                              :wrapperStyle="item.wrapperStyle"
                              @dragstart.native="(e)=>{e.preventDefault()}"
                              @click.native="showAttrDialog(key)"
                              @update:editing="updateEdit(item,$event)"
                              @deleteKeyDown="(id)=>{setCompsJsonItem(id,undefined)}"
                              @resize-start="recordHistory()"
                              @reposition-start="recordHistory()"
                              @resize="(id, wrapperStyleMergeObj)=>{handleComponentResize(id, wrapperStyleMergeObj,item)}"
                              @multi-reposition="(obj)=>{handleMultiReposition(obj)}"
                              @reposition="(id, wrapperStyleMergeObj)=>{handleComponentReposition(id, wrapperStyleMergeObj,item)}"
                              @cloneWrapper="(id, wrapperStyleMergeObj)=>{handleComponentCloneWrapper(id, wrapperStyleMergeObj,item)}"
                              @wrapperMove="(id, wrapperStyleMergeObj, moveDirection)=>{handleComponentWrapperMove(id, wrapperStyleMergeObj, moveDirection, item)}"
                              @wrapperResize="(id, wrapperStyleMergeObj, moveDirection)=>{handleComponentWrapperResize(id, wrapperStyleMergeObj, moveDirection, item)}"
          >
            <component
                slot="wrapped"
                :is="typeComponentMap[item.type]"
                :ref="key"
                class="wrapped"
                @click.native="handleComponentClick($event,item)"
                @mousedown.native="handleComponentMouseDown($event)"
                :name="item.name"
                :url="item.url"
                :type="item.type"
                :wrapperStyle="item.wrapperStyle"
                :_style="item.style"
                :settings="item.settings"
                :realtimeData="item.realtimeData"
                :events="item.events"
                :variableEvents="item.variableEvents"
                :id="item.id"
                :editing="item.editing"
                :dynamicProps="item.dynamicProps"
                :bindInfo="item.bindInfo"
                :mode="mode"
                :editType="editType"
                :productSaveForm="productSaveForm"
                :companyId="companyId"
                :fromType="fromType"
                :dialogCount="dialogCount+1"
            ></component>
          </components-wrapper>
          <!--预览模式下的变量表 -->
          <!--          <div :v-show="!isEditMode">-->
          <!--            <var-dialog-->
          <!--                :varDialogInfo="varDialogInfo"-->
          <!--                :compsJson="compsJson"-->
          <!--                :varJson="varJson"-->
          <!--                :varList="varList"-->
          <!--                :projectId="projectId"-->
          <!--                :productId="productId"-->
          <!--                :mode="mode"-->
          <!--                :fromType="fromType"-->
          <!--                @update:varJson="val => {varJson = val}"-->
          <!--            ></var-dialog>-->
          <!--          </div>-->
        </div>
      </div>
      <el-dialog
          title="提示"
          :visible.sync="exitDialogVisible"
          width="30%"
      >
        <span>是否确认离开此页面(若未保存将丢失修改记录)？</span>
        <span slot="footer" class="dialog-footer">
        <el-button @click="cancelExit">取 消</el-button>
        <el-button type="primary" @click="confirmExit">确 定</el-button>
     </span>
      </el-dialog>
    </div>
  </div>
</template>


<script>
// 引入可拖动对话框、组件wrapper
import DraggableDialog from "@/components/ProductComponents/CreateComponents/DraggableDialog";
import AttrDialog from "@/components/ProductComponents/CreateComponents/AttrDialog";
import VarDialog from "@/components/ProductComponents/CreateComponents/VarDialog";
import MultiSelectionDialog from "@/components/ProductComponents/CreateComponents/MultiSelectionDialog";
import ComponentsWrapper from "@/components/ProductComponents/CreateComponents/ComponentsWrapper";
import {typeComponentMap, typeEditorMap} from "@/components/ProductComponents/Config/typeMap"
// 深拷贝工具
import deepClone from "../../../config/deepCopy.js";
// import DOMAIN_PREFIX from "../../../config/domainPrefix.js"
import eventActionHandlerMap from "@/components/ProductComponents/Config/eventActionHandlerMap"
// import ImageMixin from "./createMixins/ImageMixin";
//
import pictureKindList from "@/components/ProductComponents/Config/pictureKindListOld"
import componentsList from "@/components/ProductComponents/Config/componentsList"
import imageSelector from "@/components/ImageComponents/ImageSelector";
import {isUnDo, listenKeyDown, listenKeyUp} from "@/components/ProductComponents/Config/keyBoardEvents";
//
// const AVATAR_PREFIX = DOMAIN_PREFIX.AVATAR_PREFIX
import API from "../../../config/api.js";
import {generatePath, handleRedirect} from "../../../config/redirectWindow";

export default {
  name: "defaultCreate",
  //mixins: [ImageMixin],
  components: {
    ComponentsWrapper,  //组件的包裹框
    imageSelector,
    DraggableDialog,  //侧边栏的框
    AttrDialog,
    VarDialog,    // 变量框组件
    MultiSelectionDialog
  },
  props: {
    // productId: Number,  // 页面id
    // companyId: Number,  //来自开发者开发页面该开发者所属公司
    // editType: Number,   // 编辑模式
    // projectId: Number,   // 项目id
    dialogCount: {  //用于模态跳转嵌套用，动态生成id以防止冲突
      type: Number,
      default: 0,
    },
    readPublished:{ //是否只读发布的页面
      type: Boolean,
      default: false,
    },
  },
  beforeDestroy() {
    if(this.pageTimer["timer1"]){
      clearInterval(this.pageTimer["timer1"]);
    }
    if(this.getVarInterval){
      clearInterval(this.pageTimer["timer1"]);
    }
  },
  watch:{
    backgroundColorValue:{
      immediate:true,
      handler(){
        console.log("iiiiiii",this.backgroundColorValue)
        this.$set(this.backgroundColor,"backgroundColor",this.backgroundColorValue)
      }
    },
  },
  data() {
    return {

      //下面四个临时写在这里
      productId: 198,  // 页面id
      companyId: 13,  //来自开发者开发页面该开发者所属公司
      editType: 3,   // 编辑模式
      projectId: 43,   // 项目id
      backgroundColorValue:'',//背景颜色
      backgroundColor:{
        backgroundColor:''
      },
      //方便跳转的时候记录
      eidtContent:{ position: 'relative',height: '80vh',float: 'left',backgroundColor: 'white',width: '80%',overflowY: 'scroll'},
      NotEidtContent:{ position: 'relative',height: '80vh',float: 'left',backgroundColor: 'white',width: '80%',overflowY: 'scroll'},
      userId: 0,   //记录页面创作者
      recordNum: 0,
      pageTimer: {}, //记录定时器，定时更新变量什么的
      mouseDownX: 0,  // 记录鼠标点击的位置
      mouseDownY: 0,
      typeComponentMap: typeComponentMap,
      typeEditorMap: typeEditorMap,
      isSaveNewConfirmShow: false, //是否展示另存页面对话框
      isMoveFormConfirmShow: false, //是否整体移动
      moveSaveForm: {       // 整体移动变量
        distance: '',
        direction: '',
        directionList: [{
          value: 'right',
          name: '向右'
        }, {
          value: 'left',
          name: '向左'
        }, {
          value: 'up',
          name: '向上'
        }, {
          value: 'down',
          name: '向下'
        }
        ]
      },
      moveSaveFormRules: {  // 草稿保存时的表单填写验证
        distance: [{
          required: true,
          message: '请输入整体移动像素',
        }
        ],
        direction: [{
          required: true,
          message: '请选择整体移动方向',
        }
        ]
      },
      productSaveNewForm: { //另存页面,新页面的信息
        title: "",  // 标题
        description: "",  // 描述
        projectId: "",  // 该页面所属项目id
        productId: "",  // 该页面id
        authorId: "",  // 作者
      },
      productSaveNewFormRules: {  // 草稿保存时的表单填写信息的要求
        title: [{
          required: true,
          message: '请输入标题',
        }
        ]
      },
      productSaveForm: {      //页面创建时存放的信息
        title: "",  // 标题
        description: "",  // 描述
        productId: "",  // 该页面id
        projectId: "",  // 该页面所属项目id 为了按钮跳转记录
        authorId: "",  // 作者
      },
      historyStack: [],       // 记录页面组件状态的栈,用于撤销
      isEditMode: undefined,          // 是否是编辑模式
      modeBtnsHidden: undefined,      // 按钮是否隐藏

      // 属性变量框信息,是否展示和展示哪个组件
      attrDialog: {
        show: true,
        componentId: undefined,    // 为undefined时为空白
      },
      varDialogInfo: {
        show: true,
      },
      compsJson: {},            //组件布局
      initialCompsJson: {},    // 初始从后端获取的CompsJson，存放组件布局
      compsNumber: {},         // 记录组件生成的id
      pictureList: [],        // 存放当前系统图库选择的图片
      varJson: {},            // 存放变量
      getVarInterval: undefined,   // 获取变量定时器
      fromType: 0,//跳转至创作模块页面的来源
      systemComponentSelectionIndex: 1,  //选择出现哪个组件框
      //系统组件菜单变化框
      systemComponentSelectionDialog: {
        show: true,
      },
      /*动态组件选择*/
      dynamicComponentDialog: {
        show: true,
      },
      componentsList: componentsList,
      /*系统图库选择框——第1级,选择大种类*/
      pictureKindDialog: {
        show: true,
      },
      /*系统图库选择框——第2级,选择具体的种类*/
      selectPictureDialog: {
        show: false,
        pictureKind: undefined,
        pictureType: undefined,
      },
      pictureKindList: pictureKindList,
      /*个人图库选择框,是否展示和查询的信息*/
      selfPictureDialog: {
        show: true,
        searchImg: '',//查询图片
      },
      //跳转页面的Dialog
      exitDialogVisible: false,
      //退出使用
      exitFunc: null,
      exitNode: null,


      selfPictureList: [], //自定义图片库
      selfPicturePageNum: 1,
      selfPicturePages: '',//总页数
      selfPictureListLoadMoreStatus: 'loadmore',

      //自选图片修改图片url调用对话框后，操作的id
      changeImageUrlId: "",
      //type分为 "change" 和 "new" 两类： change代表选择图片之后，需要为已经存在的图片组件更改一个url； new代表选择图片之后，在屏幕上新增一个图片组件，url使用新选择的
      changeImageUrlType: "",

      //侦测按键
      keyDownFlag:[],

      multiEditingCount: 0,//记录目前多选了几个元素
      wrapperClickListening: 0, //true时，组件将侦测点击事件，是否选中元素；当打开对话框时该值将置于false,用于

      //处理多选时组合
      combinationIndex: 1,
      combinationMap: {},

      activeNames: ['1'],   // 属性框展开状态
      scollLen: 0,    // 属性框滚动条
    }
  },
  // 每次页面更新都更新$ref,把数组转化为对象
  updated() {
    for (let i in this.$refs) {
      let item = this.$refs[i]
      if (item instanceof Array) {   // 这个引用是数组形式,就将其转化成对象形式
        this.$refs[i] = item[0]
      }
    }
  },
  mounted() {
    this.init();    // 初始化页面
  },

  methods: {
    updateEdit(item,val){
      if(this.wrapperClickListening===0){
        if(this.keyDownFlag[17] != true && this.keyDownFlag[16] != true){
          if(val===true){
            item.editing = true;
            item.multiEditing = true;
          }else{
            item.editing = false;
            item.multiEditing = false;
          }
          this.updateMultiComponentSelection(true);
        }else{
          if(val===true){
            item.editing = true;
            item.multiEditing = true;
          }else{
            item.editing = false;
          }
          this.updateMultiComponentSelection(false);
        }
        this.updateMultiEditingCount();
      }
    },
    //mounted初始化
    init() {
      this.userId = window.localStorage.getItem("userid");
      //初始化键盘事件
      document.onkeydown = (e) => {
        listenKeyDown(e);
      }
      document.onkeyup = (e) => {
        listenKeyUp(e);
      }
      this.$bus.$on('var-change', this.varChange)      //绑定var-change事件,回调是varChange方法
      this.$bus.$on('handle-key-down', (e)=>{this.handleKeyDown(e)});
      this.$bus.$on('handle-key-up', (e)=>{this.handleKeyUp(e)});
      //当用户打开对话框时，处理wrapperClickListening的值，当值>=1时候禁用点击事件处理多选的选中/非选中
      this.$bus.$on("handle-stop-wrapper-click-listening", ()=>{this.wrapperClickListening+=1;});
      this.$bus.$on("handle-continue-wrapper-click-listening", ()=>{
        setTimeout(()=>{
          this.wrapperClickListening-=1;
        })
      })
      this.$emit('change', 'gaile')
      this.getCompsJson()       // 查看路由，若是草稿编辑情况，进行页面获取
      //this.getSelfPicture(true)     //因为默认界面，获取自定义图库
      //1-已保存   2-已发布可读     3-已发布可交互
      if (this.editType === 1) {
        this.editModeInit();
      } else if (this.editType === 2) {     // 发布后的页面就不可以编辑了
        this.viewModeInit();      // 直接预览模式
        setTimeout(() => {
          this.$message('该页面仅读，无法交互')
        }, 1000)
      } else if (this.editType === 3) {
        this.viewModeInit();
        // setTimeout(() => {
        //   this.$message('该页面可交互')
        // }, 1000)
      }
      this.pageTimer["timer1"] = setInterval(this.saveProduct, 600000); //每间隔5分钟调用saveProduct方法对页面自动进行一次保存，防止页面修改丢失。
    },
    //編輯模式初始化
    editModeInit() {
      if (this.isEditMode) {    // 如果已经是编辑模式了,直接返回
        return;
      }
      let element_mainDiv = document.getElementById("content" + this.dialogCount);
      if (element_mainDiv !== null) element_mainDiv.style.width = "80%";    //调整画布大小为80%
      this.$message({
        message: '当前为编辑模式',
        type: 'success',
      })
      this.clearEvents()            // 清空组件的事件
      this.editModePictureInit();   //侧边栏组件展示初始化
      this.isEditMode = true        //ture是编辑模式 false是预览模式
      this.attrDialog.show = true;  //编辑模式要显示属性对话框
      this.modeBtnsHidden = false   //编辑模式按钮不隐藏
      this.varDialogInfo.show = false   //变量对话框 不显示
      this.getVarJson()             //获取变量
      clearInterval(this.getVarInterval)    // 清楚定时器,停止定时获取变量值，变量都是实时变化的数据，但编辑模式下是在绘制看不到数据的变化
    },
    //预览模式初始化
    viewModeInit() {
      if (this.isEditMode === undefined) {
        this.isEditMode = true
      }
      //画布扩展->清空事件->设置展示框初始状态->获取变量->获取事件。
      //让画布扩展到整个屏幕
      let element_mainDiv = document.getElementById("content" + this.dialogCount);
      if (element_mainDiv !== null) {
        element_mainDiv.style.width = "100%";
        if(this.dialogCount > 0){
          element_mainDiv.style.overflowY = "visible";
          //防止dialog里面重复overflow
        }
      }
      if (!this.isEditMode)    // 本身就是预览模式,直接返回
        return
      this.$message({
        type: 'success',
        message: '当前为预览模式',
      })
      this.clearEvents()  //清空事件
      this.viewModePictureInit();   //预览模式下的图片组件初始化
      this.isEditMode = false  //预览模式
      this.attrDialog.show = false   //属性框不显示
      this.varDialogInfo.show = true     //变量框显示
      this.modeBtnsHidden = true     //按钮隐藏
      this.initGetVarInterval()   //预览模式(先获取变量)，定时获取变量值
      setTimeout(() => {
        this.initEvents();      //再绑定事件,这样预览模式下,那些按钮事件才会发生
      }, 500)    // 似乎不用定时器？
    },
    newProduct() {   // 新建页面跳转
      this.$emit("toNewPage");
    },
    //处理键盘事件
    handleKeyDown(e){
      //console.log("进入键盘点击事件处理",e)
      this.keyDownFlag[e.keyCode] = true;
      if(isUnDo(this.keyDownFlag) && this.recordNum!==0){
        this.undo();
      }
      for(let i in this.compsJson){
        let wrapper = this.$refs["componentsWrapper" + i];
        //console.log("wapper",wrapper)
        if (wrapper === undefined) continue
        wrapper.handleKeyDownEvents(this.keyDownFlag);
      }
    },
    handleKeyUp(e){
      this.keyDownFlag[e.keyCode] = false;
      for(let i in this.compsJson){
        let wrapper = this.$refs["componentsWrapper" + i];
        if (wrapper === undefined) continue
        wrapper.handleKeyUpEvents();
      }
    },
    // 移动所有元素
    moveAllContent() {
      this.$refs.moveSaveForm.validate(valid => {
        if (valid) {
          this.recordHistory();
          if (this.moveSaveForm.direction === '向上') {
            for (let id in this.compsJson) {
              this.compsJson[id].wrapperStyle.top = Number(Number(this.compsJson[id].wrapperStyle.top.replace('px', '')) - this.moveSaveForm.distance) + 'px'
            }
          } else if (this.moveSaveForm.direction === '向下') {
            for (let id in this.compsJson) {
              this.compsJson[id].wrapperStyle.top = Number(Number(this.compsJson[id].wrapperStyle.top.replace('px', '')) + Number(this.moveSaveForm.distance)) + 'px'
            }
          } else if (this.moveSaveForm.direction === '向左') {
            for (let id in this.compsJson) {
              this.compsJson[id].wrapperStyle.left = Number(Number(this.compsJson[id].wrapperStyle.left.replace('px', '')) - this.moveSaveForm.distance) + 'px'
            }
          } else if (this.moveSaveForm.direction === '向右') {
            for (let id in this.compsJson) {
              this.compsJson[id].wrapperStyle.left = Number(Number(this.compsJson[id].wrapperStyle.left.replace('px', '')) + Number(this.moveSaveForm.distance)) + 'px'
            }
          }
          this.isMoveFormConfirmShow = false

        }
      });
    },
    //发布页面
    releasePage() {
      this.$confirm('请确认是否保存，确定发布？','提示', {
        cancelButtonText: "取消", // 取消按钮的文字
        confirmButtonText: "确认", // 确认按钮的文字
      }).then(()=>{
        let data = {
          id: this.productId,
          companyId: this.companyId
        }
        this.$axiosRequest({    // 请求后端,发布页面
          url: API.publishProduct,
          method: 'POST',
          data: data,
          success: res => {
            if (res.data > 0) {
              this.$message({
                message: '发布成功',
                type: "success"
              })
            } else if (res.data === -2) {
              this.$message({
                message: '参数出错，发布失败',
                type: "error"
              })
            } else if (res.data === -1) {
              this.$message({
                message: '系统错误，发布失败',
                type: "error"
              })
            }
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消发布'
        });
      });
    },
    // 整体移动
    moveFormShow() {
      if (this.compsJson.length === 0) {
        this.$message({
          message: '画布暂无组件',
          type: 'error',
        })
      } else {
        this.isMoveFormConfirmShow = true    // 展示出表单来移动
      }

    },
    //另存为页面,即新建一个页面
    validAndSaveNewProduct() {
      this.$refs.productSaveNewForm.validate(valid => {
        if (valid) {  // 保存页面
          let data = {
            title: this.productSaveNewForm.title,
            projectId: this.projectId,
            description: this.productSaveNewForm.description,
            authorId: this.userId,  // 【改为后台获取当前用户id】
            tableData: JSON.stringify(this.compsJson),
            companyId: this.companyId,
          }
          this.$axiosRequest({
            url: API.addProduct,
            method: 'POST',
            data: data,
            success: res => {
              if (res.status === 200) {
                if (res.data === 0) {
                  this.$message({
                    message: '已存在该标题草稿！',
                    type: 'error',
                  })
                } else if (res.data === -1) {
                  this.$message({
                    message: '后台错误，未保存成功，请重试！',
                    type: 'error',
                  })
                } else if (res.data > 0) {
                  // eslint-disable-next-line vue/no-mutating-props
                  this.editType = 1
                  this.productSaveNewForm.productId = res.data
                  this.$message({
                    message: '已成功另存,另存页面位于本项目最下方',
                    type: 'success',
                    // 成功后默认 2s后 自动跳转  更新路由上的editType，避免直接刷新页面回到初始草稿
                  })
                  let saveAsChild = {              //后面根据后端返回进行修改
                    projectId: this.projectId,
                    productId: this.productSaveNewForm.productId,
                    title: this.productSaveNewForm.title,
                    stageType: 3,
                  }
                  this.$emit('saveAs', saveAsChild)
                }
              }
            }
          })
          this.isSaveNewConfirmShow = false
        }
      });
    },
    // 初始化页面复现，初始化页面数据信息，这里改成获取默认界面接口
    getCompsJson() {
      let data = {
        // id: this.productId,       // 页面id
        // companyId: this.companyId
      }
      // let url;
      // if(this.readPublished){
      //   url = API.getProductPublishedById;
      // }else{
      //   url = API.getProductById;
      // }
      this.$axiosRequest({
        url: API.getSampleProduct,
        method: 'POST',
        data: data,
        success: res => {
          // console.log("获取CompsJson后的res为",res)
          if (res.status === 200) {

            this.compsJson = JSON.parse(res.data.product.tableData)       //初始化compsJson
            console.log(this.compsJson)
            if('backgroundColorValue' in this.compsJson){
              this.backgroundColorValue = this.compsJson.backgroundColorValue
              this.$delete(this.compsJson,"backgroundColorValue")
            }else{
              this.backgroundColorValue = "#FFFFFF"
            }
            this.checkCompsJson();
            this.initialCompsJson = deepClone(this.compsJson)             // 深拷贝一份compsJson给initialCompsJson
            this.productSaveForm.title = res.data.product.title           // 设置当前项目的信息
            this.productSaveForm.projectId = parseInt(res.data.product.projectId);        //为了按钮跳转记录productSaveForm的内容
            this.productSaveForm.description = res.data.product.description               //此处填充项目的描述和名字
            this.productSaveNewForm.title = this.productSaveForm.title + '-副本'           //设置另存为的时候的页面名称
            this.productSaveNewForm.description = this.productSaveForm.description + '-副本'      //设置另存为的时候的页面描述
          }
        }
      })
    },
    //检查CompsJson
    //目的：有时候修改之后的Style/wrapperStyle会缺乏"px",将style上都加上"px"
    checkCompsJson(){
      let bin=["width","height","left","top","min-width","min-height","border-width","border-height","font-size"]
      for(let key in this.compsJson){
        let data = this.compsJson[key];
        let style = data.style;
        let wrapperStyle = data.wrapperStyle;
        for(let key in style){
          if(bin.indexOf(key)>-1){
            style[key] = parseInt(style[key].toString()).toString() + "px";
          }
        }
        for(let key in wrapperStyle){
          if(bin.indexOf(key)>-1){
            wrapperStyle[key] = parseInt(wrapperStyle[key].toString()).toString() + "px";
          }
        }
        this.compsJson[key].style = style;
        this.compsJson[key].wrapperStyle = wrapperStyle;
      }
    },
    //这里需要改成默认的页面模式
    getVarJson() {  // 获取变量信息
      let data = {

      }
      //调用接口getALLVariableOfCompany获取该页面所属公司所有变量，变量信息保存在
      this.$axiosRequest({
        url: API.getSampleVariableList,
        method: 'POST',
        data: data,
        success: res => {
          if (res.status === 200) {
            // 对删除的变量进行清除，避免变量表闪烁
            for (let varJsonKey in this.varJson) {
              // eslint-disable-next-line no-prototype-builtins
              if (!res.data["variableList"].hasOwnProperty(varJsonKey)) {   // 数据库中没有当前变量的这个属性,说明被删除了
                //hasOwnProperty表示是否有自己的属性。这个方法会查找一个对象是否有某个属性
                delete this.varJson[varJsonKey]   // 删除掉这个属性
              }
            }
            // 更新变量内容
            for (let varirableKey in res.data["variableList"]) {
              let varirable = res.data["variableList"][varirableKey]
              //使用this.$set(obj, key, value)，将值都存在varJson里面
              //varJson形式是每个变量名字为key值，key值里面有各个属性
              this.$set(this.varJson, varirable["variableName"], {
                "id": varirable["id"],
                "name": varirable["variableName"],
                "value": parseInt(varirable["curValue"]),
                "description": varirable["description"],
              })  // $set赋值才能触发compute
            }
            //console.log('varJson返回内容', this.varJson)
          }
          //console.log("获取变量结束")
        }
      });
    },
    // 点击预览后执行的逻辑
    async handleView() {
      this.saveProduct();
      let url = await generatePath(this.productId,this.companyId);
      url = url.replace("read_only=true","read_only=false")
      handleRedirect(url);
    },
    //父组件点击树状图其它节点切换的时候提醒保存
    change(func, node) {
      this.exitDialogVisible = true;
      this.exitFunc = func;
      this.exitNode= node;
    },
    //取消退出
    cancelExit(){
      this.exitDialogVisible = false;
      this.$emit('testback');
    },
    confirmExit(){
      this.exitDialogVisible = false;
      this.exitFunc(this.exitNode);
    },
    // 页面保存
    saveProduct() {

    },
    // 事件绑定
    initEvents() {
      for (let id in this.compsJson) {   // 遍历组件信息,拿出事件,进行绑定
        // 事件绑定
        let events = this.compsJson[id].events
        //console.log("【initEvents】 ing...  event个数：", events)
        let bindElement = this.$refs[id]   //按钮  //用this.ref.name获取到的是组件示例，可以使用组件的所有方法
        events.forEach((event) => {
          let targetElement = this.$refs[event.target]   //绑定发生事件的图形
          // eslint-disable-next-line no-undef
          let handler = eventActionHandlerMap[event.action] //指向eventActionHandleMap中的不同事件
          bindElement.$on(event.trigger, (...args) => {
            // console.log("【initEvents】 ing...", event.trigger, this.compsJson[id].name) //【initEvents】 ing... click 按钮
            handler(args, this.compsJson[event.target], targetElement, this.compsJson[id], bindElement) //触发事件
          })
        })
        // 变量控制绑定
        let clickEvents = this.compsJson[id].clickEvents
        //console.log("点击事件为",this.compsJson[id],clickEvents)
        clickEvents.forEach((event) => {
          if (event.kind === "页面跳转") return
          //if (event.kind === "")
          // eslint-disable-next-line no-undef
          //console.log("给组件绑定了",this.compsJson[id],event,"事件")
          let handler = eventActionHandlerMap["variable-update"]
          bindElement.$on(event.trigger, (...args) => {
            handler(args, event, event.value, this, this.compsJson[id], bindElement)
          })
        })
      }
    },
    //将组建绑定事件清空
    clearEvents() {
      // console.log("清空事件执行了", this.$refs, this.compsJson)
      for (let id in this.compsJson) {
        let bindElement = this.$refs[id]  //通过 ref 为子组件赋予一个 ID 引用，在vue的js中可通过this.$refs.XXX来获取到组件对象。
        bindElement.$off()
      }
    },
    variableUpdate(varItem, value) {   //点击按钮触发的变量绑定事件
      if (varItem.kind === "执行脚本") {
        let data = {
          companyId: this.companyId,
          updateVariableId: varItem.id,
          scriptSource: encodeURIComponent(varItem.content),
          TriggerVariableIds: varItem.triId + ",",
        }
        this.$axiosRequest({
          url: API.executeSampleEventScript,
          method: 'POST',
          data: data,
          header: API.header,
        });
      }else {
        this.$axiosRequest({
          url: API.setSampleVariableValue,
          method: 'POST',
          data: {
            companyId: this.companyId,
            id: varItem.id, //变量id
            value: value    //value: "11" 变量要改为的值
          },
          header: API.header,
        });
      }
      setTimeout(()=>{this.refreshPage()},200)
    },
    refreshPage() {
      this.getVarJson()
      setTimeout(()=>{
        let msgs = []
        // 把变量值更新到对应的位置并存储报警信息
        for (let varName in this.varJson) {
          // 报警
          if (this.varJson[varName].allowAlert === true) {   //有报警信息
            if (this.varJson[varName].highAlertValue && this.varJson[varName].value >= this.varJson[varName].highAlertValue) {
              msgs.push(`变量 ${varName} 高于报警值: ${this.varJson[varName].highAlertValue}`)
            }
            if (this.varJson[varName].lowAlertValue && this.varJson[varName].value <= this.varJson[varName].lowAlertValue) {
              msgs.push(`变量 ${varName} 低于报警值: ${this.varJson[varName].lowAlertValue}`)
            }
          }
        }
        for (let id in this.compsJson) {  // 遍历组件
          let newItem = this.compsJson[id]
          //console.log("newitem  ", newItem)
          for (let settingItem in newItem.settings) { // 查看settings里每一项类型，更新数据
            let mappingDataValue = 0                      // 在组件上绑定的真实的值
            if (newItem.settings[settingItem].varName !== undefined) {  // 对象,说明绑定了变量,只有绑定变量的时候,input框的值是表单对象
              console.log(newItem.settings[settingItem].varName)
              console.log(this.varJson)
              let realtimeDataValue = parseFloat(this.varJson[newItem.settings[settingItem].varName].value)   // 获得当前变量的值
              let form = newItem.settings[settingItem]     // 绑定变量后，这个就是绑定变量时填写的表单
              if (newItem.settings[settingItem].mappingMi !== undefined) {  // 绑定映射
                // this.$set(newItem.realtimeData, settingItem, realtimeDataValue)    // 设置组件相应的属性为真实的值
                if (realtimeDataValue >= form.valueMx) realtimeDataValue = form.valueMx
                if (realtimeDataValue <= form.valueMi) realtimeDataValue = form.valueMi   // 超过范围默认落在范围内
                let gap1 = form.valueMx - form.valueMi
                let gap2 = form.mappingMx - form.mappingMi
                mappingDataValue = (realtimeDataValue - form.valueMi) / gap1 * gap2 + form.mappingMi    // 计算占的百分比,乘上差值,加上最小值
              } else if(newItem.settings[settingItem].partitionInfo !== undefined){  // 分段/均分绑定，根据规则进行数值设置
                if (realtimeDataValue >= form.valueMx) realtimeDataValue = form.valueMx
                if (realtimeDataValue <= form.valueMi) realtimeDataValue = form.valueMi
                for (let partitionIndexStr in newItem.settings[settingItem].partitionInfo) {     // 遍历分段信息
                  let partitionIndex = parseInt(partitionIndexStr)
                  let partitionMi = parseFloat(newItem.settings[settingItem].partitionInfo[partitionIndex].value)   // 本区间最小值
                  let partitionMx = form.valueMx + 1   // 区间最大值
                  if (partitionIndex < parseInt(newItem.settings[settingItem].partitionInfo.length) - 1)    // 当不是最后一个区间时
                    partitionMx = parseFloat(newItem.settings[settingItem].partitionInfo[partitionIndex + 1].value)   // 取下一个区间的标记点
                  if (realtimeDataValue >= partitionMi && realtimeDataValue < partitionMx) {
                    mappingDataValue = newItem.settings[settingItem].partitionInfo[partitionIndex].gtValue
                    break
                  }
                }
              }else {            // 原值绑定
                mappingDataValue = realtimeDataValue
                if (settingItem === "state") {
                  if (realtimeDataValue === 1) mappingDataValue = true
                  else if(realtimeDataValue === 0) mappingDataValue = false
                }
              }
            } else {  // 非对象 直接输入字符串/数值绑定
              mappingDataValue = newItem.settings[settingItem]
            }
            this.$set(newItem.realtimeData, settingItem, mappingDataValue)      // 最后设置真实的值
          }
        }
        if (msgs.length > 0) {
          this.$message({
            message: msgs.join("\n"),
            type: 'warning',
          })
        }
      },200)
    },
    // 在预览模式下,每隔十秒,根据变量表id获取实际数值给 realtimeData，更新setting中的值给realtimeData
    initGetVarInterval() {
      this.refreshPage()
      setTimeout(()=>{
        this.refreshPage()
      },1500)
      this.getVarInterval = setInterval(()=>{
        this.refreshPage()
      }, 10000)
    },
    //   // e：事件对象	item：选中的组件在componentsList中的对象
    dragStartFromList(e, item) {
      // console.log("dragStartFromList被执行了", item.url)
      //console.log(e, e.type, e.originalEvent)
      if (item.type === 'img') {
        //console.log("dragStartFromList", e, item)
        //console.log('拖出图片', item)
        let imgUrl = item.url
        // console.log('拖出图片', imgUrl)
        var img = new Image()
        img.src = imgUrl
        //console.log('拖出图片长宽=', img.height, img.width)
        img.width = '100'
        img.height = '100'
        item.wrapperStyle.width = img.width + 'px'
        item.wrapperStyle.height = img.height + 'px'
        item.style.width = img.width + 'px'
        item.style.height = img.height + 'px'
        item.settings.width = img.width
        item.settings.height = img.height
        item.realtimeData.width = img.width
        item.realtimeData.height = img.height
        //console.log('更改后拖出图片', item)
      }
      // 只支持存储字符串 这里将item 转为JSON串
      //this.itemTest = item;
      e.dataTransfer.setData("componentInfo", JSON.stringify(item))
      e.dataTransfer.setData("innerLeft", e.offsetX - this.$el.offsetLeft)
      e.dataTransfer.setData("innerTop", e.offsetY - this.$el.offsetTop)
    },
    // 从compsDialog中拖动组件，放在content上调用的函数
    dropOnContent(e) {
      //let componentInfo = this.itemTest;
      //console.log("drop")
      let div_content = document.getElementById('content' + this.dialogCount);
      // 防止默认事件
      e.preventDefault()
      // 从e.dataTransfer获取componentInfo（即上面的item）并解析
      let componentInfo = JSON.parse(e.dataTransfer.getData("componentInfo"))
      // 生成默认id
      let number = this.compsNumber[componentInfo.name] !== undefined ? this.compsNumber[componentInfo.name] + 1 : 0
      // 因为组件id可以修改，所以下一个number可能已经被占用，所以如果已存在，不断后延
      while (this.compsJson[componentInfo.name + '-' + number]) {
        number++
      }
      this.compsNumber[componentInfo.name] = number
      // 深拷贝
      let newItem = deepClone(componentInfo)
      // 设置id
      newItem.id = componentInfo.name + '-' + number

      newItem.editing = false
      // 设置默认style，首先合并componentsList中的默认设置
      newItem.style = {...(newItem.style ? newItem.style : {})}
      newItem.wrapperStyle = {...(newItem.wrapperStyle ? newItem.wrapperStyle : {})}
      // 设置style中的默认位置,原本-0.19，-0.21，此处决定了刚拖动到画布上时组件的位置
      newItem.wrapperStyle.left = (e.clientX - document.body.clientWidth * 0.165 + div_content.scrollLeft) + "px"
      newItem.wrapperStyle.top = (e.clientY - document.body.clientHeight * 0.195 + div_content.scrollTop) + "px"
      // 设置绝对定位
      newItem.wrapperStyle.position = 'absolute'
      //设置默认settings，主要是一些所有组件都有的设置选项，比如z-index（用来控制元素堆叠时的显示顺序）
      // z-index默认为10
      newItem.settings["z-index"] = 10
      newItem.events = newItem.events ? newItem.events : []
      newItem.variableEvents = newItem.variableEvents ? newItem.variableEvents : []
      newItem.clickEvents = newItem.clickEvents ? newItem.clickEvents : []

      newItem.dynamicProps = newItem.dynamicProps ? newItem.dynamicProps : {}
      newItem.bindInfo = newItem.bindInfo ? newItem.bindInfo : {}
      this.setCompsJsonItem(newItem.id, newItem)
    },
    dragOverOnContent(e) {
      e.preventDefault();
    },
    // 展示属性框,传入组件的key值即可
    showAttrDialog(componentId) {
      if (!this.isEditMode)
        return
      //console.log("componentId", componentId)
      this.attrDialog.show = true
      this.attrDialog.componentId = componentId
    },
    //属性框内部选择选中组件
    changeShowAttr(componentId){
      this.attrDialog.show = true
      this.attrDialog.componentId = componentId
      this.updateEdit(this.compsJson[componentId],true) //自动选中组件
      //把其他组件都去掉选中
      for(let key in this.compsJson){
        if(key != componentId){
          this.updateEdit(this.compsJson[key],false)
        }
      }
    },
    //总线监听变量改变触发的函数
    varChange(varName, value) {
      console.log('变量发生改变', varName, value);
      let varId;
      for (let key in this.varJson) { //varJson变量信息
        //console.log('寻找varName对应的id', key)
        if (key === varName) {
          varId = this.varJson[key].id
        }
      }
      this.$axiosRequest({
        url: API.setSampleVariableValue,
        method: 'POST',
        data: {
          companyId: this.companyId,
          id: varId,
          value: value
        },
        header: API.header,
        success: res => {
          if (res.status === 200) {
            if (res.data > 0) {
              this.$message({
                title: '修改成功，等待更新',
                type: 'success',
              })
            }
            this.refreshPage();
          }
        }
      });
    },
    //撤销
    undo() {
      this.attrDialog.componentId = undefined    // 属性框不显示内容
      this.attrDialog.show = true
      let pre = this.historyStack.pop()   //把最上方的最近时间的画布状态从栈顶pop出来
      this.compsJson = pre ? pre : {}     //更新页面组件状态
      this.recordNum--;
    },
    // 添加一个新组件到ComsJson中
    setCompsJsonItem(id, newItem) {
      this.recordHistory()
      if (!newItem) {
        this.$delete(this.compsJson, id)
      } else {
        this.$set(this.compsJson, id, deepClone(newItem))   //深拷贝一个新的设置到compsJson中
      }
    },
    // 记录历史记录
    recordHistory() {
      //console.log('this.compsJson记录历史=', this.compsJson)
      // 最多记录64步
      if (this.historyStack.length >= 64) {
        this.historyStack.shift()       //shift（）删除数组中的第一个元素，并返回该元素
      }
      this.historyStack.push(deepClone(this.compsJson));  //将最新的画布状态入栈
      this.recordNum++;
    },
    // 把e复制一份，加上日期，加入画布中
    cloneWrapper(e) {
      let number = this.compsNumber[e.name] !== undefined ? this.compsNumber[e.name] + 1 : 0
      // 因为组件id可以修改，所以下一个number可能已经被占用，所以如果已存在，不断后延
      while (this.compsJson[e.name + '-' + number]) {
        number++
      }
      this.compsNumber[e.name] = number
      e.id = e.name + '-' + number
      this.$set(this.compsJson, e.id, e)
      return e.id
    },
    // 重新设置组件大小
    handleComponentResize(id, wrapperStyleMergeObj, item) {
      // 用styleMergeObj中有的属性覆盖item.style中对应的属性
      console.log("重新设置组件大小",wrapperStyleMergeObj,item)
      //wrapperStyleMergeObj的属性会覆盖前面的属性
      item.wrapperStyle = {...item.wrapperStyle, ...wrapperStyleMergeObj}
      this.$set(item.realtimeData, "width", item.wrapperStyle.width.replace('px', ''))
      this.$set(item.realtimeData, "height", item.wrapperStyle.height.replace('px', ''))
      this.$set(item.style, "width", item.wrapperStyle.width)
      this.$set(item.style, "height", item.wrapperStyle.height)
      let newItem = deepClone(item)
      console.log("新生成的组件为",newItem)
      this.compsJson[id] = newItem
    },
    // 更新组件位置
    handleComponentReposition(id, wrapperStyleMergeObj, item) {
      item.wrapperStyle = {...item.wrapperStyle, ...wrapperStyleMergeObj};
      let newItem = deepClone(item)
      this.compsJson[id] = newItem
    },
    // 复制一个组件
    async handleComponentCloneWrapper(id, wrapperStyleMergeObj, item) {
      //console.log('克隆打印wrapperStyle的值=', item.wrapperStyle)
      let newItem = deepClone(item)
      item.editing = false        // 复制后取消原来组件的选中
      item.multiEditing = false
      let aTop = (parseInt(newItem.wrapperStyle.top.replace('px', '')) + 20) + 'px'
      let aLeft = (parseInt(newItem.wrapperStyle.left.replace('px', '')) + 20) + 'px'
      this.$set(newItem.wrapperStyle, 'top', aTop)
      this.$set(newItem.wrapperStyle, 'left', aLeft)
      let newComponentId = await this.cloneWrapper(newItem)
      console.log("你现在要看这里，看复制出来的组件",newComponentId)
      this.attrDialog.componentId = newComponentId
    },
    handleComponentWrapperMove(id, wrapperStyleMergeObj, moveDirection, item) {
      console.log("handleComponentWrapperMove",id)
      if (moveDirection === 'left') {
        item.wrapperStyle.left = (parseInt(item.wrapperStyle.left.replace('px', '')) - 1) + 'px'
      } else if (moveDirection === 'right') {
        item.wrapperStyle.left = (parseInt(item.wrapperStyle.left.replace('px', '')) + 1) + 'px'
      } else if (moveDirection === 'up') {
        item.wrapperStyle.top = (parseInt(item.wrapperStyle.top.replace('px', '')) - 1) + 'px'
      } else if (moveDirection === 'down') {
        item.wrapperStyle.top = (parseInt(item.wrapperStyle.top.replace('px', '')) + 1) + 'px'
      }

      this.$set(item.realtimeData, "left", item.wrapperStyle.left.replace('px', ''))
      this.$set(item.realtimeData, "top", item.wrapperStyle.top.replace('px', ''))
      this.$set(item.settings, "left", item.wrapperStyle.left.replace('px', ''))
      this.$set(item.settings, "top", item.wrapperStyle.top.replace('px', ''))

      let newItem = deepClone(item)
      this.compsJson[id] = newItem
    },
    handleComponentWrapperResize(id, wrapperStyleMergeObj, moveDirection, item) {
      //console.log("修改大小",item)
      //item.wrapperStyle = {...item.wrapperStyle, ...wrapperStyleMergeObj}
      if (moveDirection === 'down') {
        item.wrapperStyle.height = (parseInt(item.wrapperStyle.height.replace('px', '')) + 1) + 'px'
        item.style.height = (parseInt(item.wrapperStyle.height.replace('px', '')) + 1) + 'px'
      } else if (moveDirection === 'up') {
        item.wrapperStyle.height = (parseInt(item.wrapperStyle.height.replace('px', '')) - 1) + 'px'
        item.style.height = (parseInt(item.wrapperStyle.height.replace('px', '')) - 1) + 'px'
      } else if (moveDirection === 'right') {
        item.wrapperStyle.width = (parseInt(item.wrapperStyle.width.replace('px', '')) + 1) + 'px'
        item.style.width = (parseInt(item.wrapperStyle.width.replace('px', '')) + 1) + 'px'
      } else if (moveDirection === 'left') {
        item.wrapperStyle.width = (parseInt(item.wrapperStyle.width.replace('px', '')) - 1) + 'px'
        item.style.width = (parseInt(item.wrapperStyle.width.replace('px', '')) - 1) + 'px'
      }
      this.$set(item.realtimeData, "height", item.wrapperStyle.height.replace('px', ''))
      this.$set(item.realtimeData, "width", item.wrapperStyle.width.replace('px', ''))
      let newItem = deepClone(item)
      this.compsJson[id] = newItem
    },
    // 鼠标点下,更新鼠标点击位置
    handleComponentMouseDown(e) {
      this.mouseDownX = e.clientX
      this.mouseDownY = e.clientY
    },
    // 点击组件
    handleComponentClick(e, item) {
      if (!(this.mouseDownX === e.clientX && this.mouseDownY === e.clientY) && item.editing) {
        e.stopPropagation()     // 阻止事件向上传播
      }
    },
    //处理多选时的移动，传进来的item中获得top/left的偏移量，然后让所有元素偏移一定的值
    handleMultiReposition(item){
      let leftOffset = item.leftOffset;
      let topOffset = item.topOffset;
      for(let id in this.compsJson){
        if(this.compsJson[id].multiEditing && !this.compsJson[id].realtimeData.isLock){
          let item = this.compsJson[id];
          item.wrapperStyle.left = (parseInt(item.wrapperStyle.left.replace('px', '')) + leftOffset) + 'px'
          item.wrapperStyle.top = (parseInt(item.wrapperStyle.top.replace('px', '')) + topOffset) + 'px'
          let newItem = deepClone(item)
          this.compsJson[id] = newItem;
          //this.setCompsJsonItem(id, newItem)
        }
      }
    },
    // 处理编辑框修改属性
    handleComponentEdited(newSettings, styleMergeObj, wrapperStyleMergeObj, newEvents, newBindInfo, newClickEvents) {
      let newItem = deepClone(this.compsJson[this.attrDialog.componentId])
      newItem.wrapperStyle = deepClone(this.compsJson[this.attrDialog.componentId].wrapperStyle)
      // 先克隆再获取数值
      newItem.realtimeData = deepClone(newSettings)
      newItem.settings = deepClone(newSettings)      // 到这里,newSettings的使命就完成了
      for (let settingItem in newItem.settings) { // 查看settings里每一项类型，更新数据
        let mappingDataValue = 0                      // 在组件上绑定的真实的值
        if (newItem.settings[settingItem].varName !== undefined) {  // 对象,说明绑定了变量,只有绑定变量的时候,input框的值是表单对象
          let realtimeDataValue = parseFloat(this.varJson[newItem.settings[settingItem].varName].value)   // 获得当前变量的值
          let form = newItem.settings[settingItem]     // 绑定变量后，这个就是绑定变量时填写的表单
          if (newItem.settings[settingItem].mappingMi !== undefined) {  // 绑定映射
            // this.$set(newItem.realtimeData, settingItem, realtimeDataValue)    // 设置组件相应的属性为真实的值
            if (realtimeDataValue >= form.valueMx) realtimeDataValue = form.valueMx
            if (realtimeDataValue <= form.valueMi) realtimeDataValue = form.valueMi   // 超过范围默认落在范围内
            let gap1 = form.valueMx - form.valueMi
            let gap2 = form.mappingMx - form.mappingMi
            mappingDataValue = (realtimeDataValue - form.valueMi) / gap1 * gap2 + form.mappingMi    // 计算占的百分比,乘上差值,加上最小值
          } else if(newItem.settings[settingItem].partitionInfo !== undefined){  // 分段/均分绑定，根据规则进行数值设置
            if (realtimeDataValue >= form.valueMx) realtimeDataValue = form.valueMx
            if (realtimeDataValue <= form.valueMi) realtimeDataValue = form.valueMi
            for (let partitionIndexStr in newItem.settings[settingItem].partitionInfo) {     // 遍历分段信息
              let partitionIndex = parseInt(partitionIndexStr)
              let partitionMi = parseFloat(newItem.settings[settingItem].partitionInfo[partitionIndex].value)   // 本区间最小值
              let partitionMx = form.valueMx + 1   // 区间最大值
              if (partitionIndex < parseInt(newItem.settings[settingItem].partitionInfo.length) - 1)    // 当不是最后一个区间时
                partitionMx = parseFloat(newItem.settings[settingItem].partitionInfo[partitionIndex + 1].value)   // 取下一个区间的标记点
              if (realtimeDataValue >= partitionMi && realtimeDataValue < partitionMx) {
                mappingDataValue = newItem.settings[settingItem].partitionInfo[partitionIndex].gtValue
                break
              }
            }
          }else {            // 原值绑定
            mappingDataValue = realtimeDataValue
            if (settingItem === "state") {
              if(realtimeDataValue === 0) mappingDataValue = false
              else mappingDataValue = true
            }
          }
        } else {  // 非对象 直接输入字符串/数值绑定
          mappingDataValue = newItem.settings[settingItem]
        }
        this.$set(newItem.realtimeData, settingItem, mappingDataValue)      // 最后设置真实的值
      }

      newItem.style = {...this.compsJson[this.attrDialog.componentId].style, ...styleMergeObj}

      newItem.wrapperStyle = {...newItem.wrapperStyle, ...wrapperStyleMergeObj}
      // for(let settingItem in newItem.wrapperStyle){
      //   if(settingItem === 'position'){
      //     this.$set(newItem.wrapperStyle,'position','absolute')
      //   }
      //   if(settingItem === 'transform'){
      //     this.$set(newItem.wrapperStyle,settingItem,newItem.wrapperStyle[settingItem].replace('px', ''))
      //   }
      //   if(settingItem === 'z-index'){
      //     this.$set(newItem.wrapperStyle,settingItem,newItem.wrapperStyle[settingItem].replace('px', ''))
      //   }
      //   if(settingItem === 'top' || settingItem === 'left'){
      //     this.$set(newItem.wrapperStyle,settingItem,newItem.wrapperStyle[settingItem].replace('px', '') + 'px')
      //   }
      // }
      //console.log("newItem.wrapperStyle",newItem.wrapperStyle)
      newItem.style.width = newItem.wrapperStyle.width      //解决拖拽组件后组件大小不变的问题
      newItem.style.height = newItem.wrapperStyle.height    //解决拖拽组件后组件大小不变的问题
      newItem.events = deepClone(newEvents)
      //newItem.variableEvents = deepClone(newVariablesEvents)
      newItem.clickEvents = deepClone(newClickEvents)
      newItem.bindInfo = deepClone(newBindInfo)
      this.setCompsJsonItem(newItem.id, newItem)
    },
    //编辑模式下，右边组件栏展示属性初始化
    editModePictureInit() {
      this.systemComponentSelectionDialog.show = true  //系统组件对话框 显示
      this.dynamicComponentDialog.show = true //动态对话框的一个对象  显示
      this.pictureKindDialog.show = true  //图片库对话框 显示对话框
      this.selfPictureDialog.show = true  //自定义图片库对话框 显示
    },
    //预览模式下，图片库初始化
    viewModePictureInit() {
      this.systemComponentSelectionDialog.show = false  //系统组件对话框 不显示
      this.dynamicComponentDialog.show = false  //组件框的一个对象 不显示
      this.pictureKindDialog.show = false  //图片库对话框 不显示
      this.selfPictureDialog.show = false  //自定义对话框不显示
    },
    // 更新相应变量的最大值和最小值
    updateVarjson(name,mx,mi) {
      this.varJson[name].maxValue = mx
      this.varJson[name].minValue = mi
    },

    //从图片组件emit得到，用户需要重新选择图片组件绑定的图片，这里获取需要修改的组件id
    handleChangeImageUrl(id){
      this.changeImageUrlType = "change"
      this.changeImageUrlId = id;
      this.$refs.imageSelector.openDialog();
    },
    //从上面的【插入图片】按钮来新建一个图片组件
    createImageComponent(){
      this.changeImageUrlType = "new"
      this.$refs.imageSelector.openDialog();
    },
    //选择完图片之后回调
    handleImgSelection(url){
      if(this.changeImageUrlType==="change"){
        let data = this.compsJson[this.changeImageUrlId];
        data.url = url;
        this.setCompsJsonItem(this.changeImageUrlId,data);
      }
      //下面开始新建图片组件
      else if(this.changeImageUrlType==="new"){
        // 从e.dataTransfer获取componentInfo（即上面的item）并解析
        let componentInfo;
        for(let index in this.componentsList){
          if(this.componentsList[index].type==="img"){
            componentInfo = this.componentsList[index];
          }
        }
        // 生成默认id
        let number = this.compsNumber[componentInfo.name] !== undefined ? this.compsNumber[componentInfo.name] + 1 : 0
        // 因为组件id可以修改，所以下一个number可能已经被占用，所以如果已存在，不断后延
        while (this.compsJson[componentInfo.name + '-' + number]) {
          number++
        }
        this.compsNumber[componentInfo.name] = number
        // 深拷贝
        let newItem = deepClone(componentInfo)
        //根据选择图片的url,初始化新图片组件的长宽大小
        let img = new Image()
        img.src = url + this.companySuffix;
        setTimeout(()=>{
          newItem.wrapperStyle.width = img.width + 'px'
          newItem.wrapperStyle.height = img.height + 'px'
          newItem.style.width = img.width + 'px'
          newItem.style.height = img.height + 'px'
          newItem.settings.width = img.width
          newItem.settings.height = img.height
          newItem.realtimeData.width = img.width
          newItem.realtimeData.height = img.height
          // 设置id
          newItem.id = componentInfo.name + '-' + number
          //图片赋值url
          newItem.url = url;
          newItem.editing = false
          // 设置默认style，首先合并componentsList中的默认设置
          newItem.style = {...(newItem.style ? newItem.style : {})}
          newItem.wrapperStyle = {...(newItem.wrapperStyle ? newItem.wrapperStyle : {})}
          // 设置style中的默认位置
          newItem.wrapperStyle.left = 20 + "px"
          newItem.wrapperStyle.top = 20 + "px"
          // 设置绝对定位
          newItem.wrapperStyle.position = 'absolute'
          //设置默认settings，主要是一些所有组件都有的设置选项，比如z-index（用来控制元素堆叠时的显示顺序）
          // z-index默认为10
          newItem.settings["z-index"] = 10
          newItem.events = newItem.events ? newItem.events : []
          newItem.variableEvents = newItem.variableEvents ? newItem.variableEvents : []
          newItem.clickEvents = newItem.clickEvents ? newItem.clickEvents : []
          newItem.dynamicProps = newItem.dynamicProps ? newItem.dynamicProps : {}
          newItem.bindInfo = newItem.bindInfo ? newItem.bindInfo : {}
          this.setCompsJsonItem(newItem.id, newItem)
        },500);
      }
    },
    //通过option 实现多选元素的操作
    handleMultiOptions(option){
      this.recordHistory();
      let bin = [];
      for(let id in this.compsJson){
        if(this.compsJson[id].multiEditing){
          bin[id] = deepClone(this.compsJson[id])
        }
      }
      let flag = {}
      for(let id in bin) {
        if (bin[id].editing === true) {
          flag = bin[id]
          break;
        }
      }
      switch (option){
          //向左对齐
        case "align-left":{
          let val = parseInt(flag.wrapperStyle.left.replace('px', ''))
          for(let id in bin){
            bin[id].wrapperStyle.left = val + 'px'
          }
          break;
        }
          //向右对齐
        case "align-right":{
          let val = parseInt(flag.wrapperStyle.left.replace('px', ''))+parseInt(flag.wrapperStyle.width.replace('px', ''))
          for(let id in bin){
            bin[id].wrapperStyle.left = (val - parseInt(bin[id].wrapperStyle.width.replace('px', ''))) + 'px'
          }
          break;
        }
        case "align-top":{
          let val = parseInt(flag.wrapperStyle.top.replace('px', ''));
          for(let id in bin){
            bin[id].wrapperStyle.top = val + 'px'
          }
          break;
        }
        case "align-bottom":{
          let val = parseInt(flag.wrapperStyle.top.replace('px', ''))+parseInt(flag.wrapperStyle.height.replace('px', ''));
          for(let id in bin){
            bin[id].wrapperStyle.top = (val - parseInt(bin[id].wrapperStyle.height.replace('px', ''))) + 'px'
          }
          break;
        }
        case "horizontal-center":{
          let mid = parseInt(flag.wrapperStyle.top.replace('px', '')) + parseInt(flag.wrapperStyle.height.replace('px', '')) / 2;
          for(let id in bin){
            bin[id].wrapperStyle.top = (mid - Math.floor(parseInt(bin[id].wrapperStyle.height.replace('px', '')) / 2)) + 'px';
          }
          break;
        }
        case "vertical-center":{
          let mid = parseInt(flag.wrapperStyle.left.replace('px', '')) + parseInt(flag.wrapperStyle.width.replace('px', '')) / 2;
          for(let id in bin){
            bin[id].wrapperStyle.left = (mid - Math.floor(parseInt(bin[id].wrapperStyle.width.replace('px', '')) / 2)) + 'px';
          }
          break;
        }
        case "vertical-divide":{
          let val = [];
          for(let id in bin){
            let sup = parseInt(bin[id].wrapperStyle.top.replace('px', ''));
            val.push({
              val: Math.floor(sup),
              id: id
            });
          }
          val.sort((a,b)=>{
            return a.val - b.val
          });
          let dep = val.length - 1,rest = val[val.length-1].val - val[0].val, sum = val[0].val;
          for (let i = 1;i < val.length - 1;i++){
            let length = Math.ceil(rest / dep);
            rest -= length;
            dep -= 1;
            sum += length;
            bin[val[i].id].wrapperStyle.top = sum + 'px';
          }
          break;
        }
        case "horizontal-divide":{
          let val = [];
          for(let id in bin){
            let sup = parseInt(bin[id].wrapperStyle.left.replace('px', ''));
            val.push({
              val: Math.floor(sup),
              id: id
            });
          }
          val.sort((a,b)=>{
            return a.val - b.val
          });
          let dep = val.length - 1,rest = val[val.length-1].val - val[0].val, sum = val[0].val;
          for (let i = 1;i < val.length - 1;i++){
            let length = Math.ceil(rest / dep);
            rest -= length;
            dep -= 1;
            sum += length;
            bin[val[i].id].wrapperStyle.left = sum + 'px';
          }
          break;
        }
        case "uniform-size":{
          let midWidth = parseInt(flag.wrapperStyle.width.replace('px', ''));
          let midHeight = parseInt(flag.wrapperStyle.height.replace('px', ''));
          for(let id in bin){
            bin[id].wrapperStyle.width = midWidth + 'px';
            bin[id].wrapperStyle.height = midHeight + 'px';
            bin[id].style.width = midWidth + 'px';
            bin[id].style.height = midHeight + 'px';
            bin[id].settings.width = midWidth;
            bin[id].settings.height = midHeight;
            bin[id].realtimeData.width = midWidth;
            bin[id].realtimeData.height = midHeight;
          }
          break;
        }
      }
      for(let id in bin){
        this.compsJson[id] = bin[id];
      }
    },
    updateMultiEditingCount(){
      let count = 0;
      for(let id in this.compsJson){
        if(this.compsJson[id].multiEditing){
          ++count;
        }
      }
      this.multiEditingCount = count;
    },
    //将 多选中的所有元素 加入到一个组合中
    handleAddCombination(){
      let index = this.combinationIndex++;
      for(let id in this.compsJson){
        if(this.compsJson[id].multiEditing || this.compsJson[id].editing){
          this.combinationMap[id] = index;
        }
      }
    },
    //取消组合
    handleDeleteCombination(){
      for(let id in this.compsJson){
        if(this.compsJson[id].multiEditing || this.compsJson[id].editing){
          this.combinationMap[id] = null;
        }
      }
    },
    handleAddMultiEditing(id){
      let index = this.combinationMap[id];
      this.compsJson[id].multiEditing = true;
      if(index && index > 0){
        for(let name in this.compsJson){
          if(this.combinationMap[name] === index)
            this.compsJson[name].multiEditing = true;
        }
      }
    },
    //当用户重新选择某一个组件（不按住ctrl）时，要将该组件所对应的全部组合信息全部选中
    updateMultiComponentSelection(flag){
      let index = null;
      for(let name in this.compsJson){
        if(this.compsJson[name].editing === true){
          index = this.combinationMap[name];
        }
      }
      if(flag) {
        for (let name in this.compsJson) {
          if(this.compsJson[name].editing === false){
            this.compsJson[name].multiEditing = false;
          }
        }
      }
      if(index && index > 0){
        for(let name in this.compsJson){
          if(this.combinationMap[name] === index) {
            this.compsJson[name].multiEditing = true;
          }
        }
      }
    }
  },
  computed: {
    applyContent(){
      return {
        'editContent':this.isEditMode,
        'viewContent':!this.isEditMode
      }
    },
    // 存在画布上的组件的名称
    elementsList() {
      let elementsList = []
      for (let id in this.compsJson) {
        elementsList.push(this.compsJson[id])
      }
      return elementsList
    },
    // content() {
    //   if(this.isEditMode){
    //     return { position: 'relative',height: '80vh',float: 'left',backgroundColor: 'white',width: '80%',overflowY: 'scroll'}
    //   }else{
    //     return { position: 'relative',height: '89vh',float: 'left',backgroundColor: 'white',width: '80%',overflowY: 'scroll'}
    //   }
    // },
    // 变量值列表
    varList: {
      get() {
        let varList = []
        for (let key in this.varJson) {
          varList.push(this.varJson[key])
        }
        varList.sort(function (var1, var2) {
          if (var1.id < var2.id) return -1
          else if (var1.id > var2.id) return 1
          else return 0
        })
        return varList
      },
    },
    mode() {
      return this.isEditMode ? 'edit' : 'view'   // 根据是否是isEditMode,返回当前的页面状态,编辑或者是预览
    }
  }

}
</script>

<style lang="less" scoped>
#wholePage {
  height: 100%;
  #create {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    // width: 1530px;
    width: 100%;
    //height: 80%;
    height:calc(89vh - 7%);
    position: relative;

    #right_menu {
      position: relative;
      height: 80vh;
      width: 20%;
      float: right;
      background-color: #ececec;
      // overflow: hidden;
      overflow-y: scroll;
    }

    .firstMenu {
      height: 30px;
      background-color: #d2d3d5;

      .titleMenu {
        font-size: 18px;
        font-weight: 800;
        text-align: center;
      }
    }

    .subMenu {
      height: 30px;
      margin-top: 20px;
      margin-bottom: 10px;

      .subtitleMenu {

        font-size: 17px;
        font-weight: 400;
        text-align: center;
      }
    }

    .line_01 {
      height: 0.3px;
      border-top: 1px solid #ddd;
      text-align: center;
      position: relative;
      // top: -8px;
      margin: 10px 0px 10px 0px; // 上 右 下 左
      background-color: rgba(220, 220, 220, 0.8);
      //padding: 0 20px;
    }

    .conponentsListItemContainer {
      width: 30%;
      float: left;
      padding: 1%;
      text-align: center;
      margin-bottom: 8px;
      font-size: 14px!important;
      // height: auto;
      min-height: 75px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .conponentsListItemImgContainer {
        display: flex;
        align-items: center;
        min-height: 45px;
      }
    }

    .content5 {
      height: 150px;
      overflow-y: auto;
    }

    .content6 {
      height: 450px;
      overflow-y: auto;
    }

    .content2 {
      height: 180px;
      overflow-y: auto;
    }

    .content3 {
      height: 255px;
      overflow-y: auto;

      .emptyListPosition {
        display: flex;
        flex-direction: column;
        justify-content: center;
      }

      .loadMorePosition {
        margin-top: 10px;
        // margin-left: 30%;
        // position: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
    }

    .content4 {
      display: flex;
      align-items: center;
      width: 100%;
      color: red;
    }

    .conponentsListItemContainer2 {
      width: 30%;
      float: left;
      padding: 1%;
      text-align: center;
      margin-bottom: 8px;
      height: 200px;
      // min_height:300px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      // height: 220px;
      // overflow-y: auto;

      .conponentsListItemImgContainer2 {
        display: flex;
        align-items: center;
        min-height: 10px;
      }
    }

    .conponentsListItemContainer3 {
      width: 30%;
      float: left;
      padding: 1%;
      text-align: center;
      margin-bottom: 8px;
      height: auto;
      min-height: 80px; //这个可以改变图和字之间的距离
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .conponentsListItemImgContainer3 {
        display: flex;
        align-items: center;
        min-height: 45px;
      }
    }


    .conponentsListItemContainer4 {
      width: 30%;
      float: left;
      padding: 1%;
      text-align: center;
      margin-bottom: 8px;
      height: auto;
      min-height: 150px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .conponentsListItemImgContainer4 {
        display: flex;
        align-items: center;
        min-height: 45px;
        margin: 0 auto;
      }

      .conponentsListItemImgName {
        display: flex;
        align-items: center;
        min-height: 25px;
      }
    }

    //系统组件菜单的样式
    .conponentsListItemContainer5 {
      padding: 1%;
      text-align: center;
      margin-bottom: 8px;
      height: auto;
      display: flex;
      flex-direction: row;
      justify-content: space-between;

    }

    .conponentsListItemImg {
      max-width: 100%;
      //height: 100px;
      //width: 100px;
    }

    //选择图片中图片的大小
    .conponentsListItemImg2 {
      width: 50px;
      height: 50px;
    }

    .conponentsListItemImg3 {
      max-width: 100%;
      min-height: 80px;
    }

    .editContent {
      position: relative;
      height: 80vh;
      float: left;
      background-color: #ffffff;
      width: 80%;
      overflow-y: scroll;
    }
    .viewContent {
      position: relative;
      height: 89vh;
      background-color: #ffffff;
      width: 100vw!important;
      overflow-y: scroll;
    }

    .modeMenu {
      &.hidden {
        opacity: 0;
      }

      &:hover {
        opacity: 1;
      }
    }
  }

  .modeBtns2 {
    width: 100%;
    left: 0
  }

  .modeBtns {
    position: relative;
    // top: 10px;
    // left: 0;
    // right: 0;
    // height: 80px;
    bottom: 10px;
    height: 7%;
    width: 100%;
    background-color: #ececec;
    display: flex;
    justify-content: space-around;
    align-items: flex-start;
    transition: opacity 0.5s;
    z-index: 1;
    &.hidden {
      opacity: 0; //让元素不显示，但存在/占位
    }

    &:hover {
      opacity: 1;
    }

    .editModeBtn {

    }
  }
  //另存对话框
  .saveNew{
    ::v-deep .el-dialog{
      position:absolute;
      transform:translate(-50%,-50%);
      top:30%;
      left: 50%;
      z-index:10000!important;
    }
  }
}

</style>